export default "__VITE_ASSET__7e2f4275__"